import config from './configs';
import AdminService from './core/Admin';

const adminService = new AdminService(config.services.admin.endpointName);

export { adminService };